import {
  ChangeDetectionStrategy,
  Component,
  effect,
  input,
  model,
  signal,
} from '@angular/core';
import { ModalService } from '@features/modals/services/modal.service';
import { InventoryTemplateComponent } from '@core/components/inventory-template/inventory-template.component';
import { SocketService } from '@core/services/socket.service';
import { Skin } from '@core/interfaces/skin.interface';
import { BalanceEnum } from '@core/enums/balance.enum';

@Component({
  selector: 'app-upgrader-deposit-modal',
  imports: [InventoryTemplateComponent],
  templateUrl: './upgrader-deposit-modal.component.html',
  styleUrl: './upgrader-deposit-modal.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
})
export class UpgraderDepositModalComponent {
  readonly type = input<keyof typeof BalanceEnum>(BalanceEnum.skins);
  readonly pure = model<boolean>(false);
  readonly selectedSkins = model<Skin[]>([]);
  readonly isProcessing = signal(false);

  constructor(
    private socketService: SocketService,
    private modalService: ModalService
  ) {
    effect(() => {
      this.pure.set(this.type() === BalanceEnum.pure);
    });
  }

  public async depositItems() {
    this.isProcessing.set(true);
    try {
      const trade: { offerid: number; hash: string } =
        await this.socketService.emit('inventory_deposit', {
          skins: this.selectedSkins(),
          balance: this.type(),
        });

      this.modalService.openModal('TradeModal', {
        tradeModalOptions: {
          trade_offer_id: trade.offerid,
          trade_hash: trade.hash,
          trade_skins: this.selectedSkins(),
          typography_trade_for:
            this.type() === BalanceEnum.pure
              ? 'deposit pure items to upgrader'
              : 'deposit skins to upgrader',
        },
        balance: this.type(),
      });
      this.modalService.closeModals(['UpgraderDepositModal']);
    } catch {
    } finally {
      this.isProcessing.set(false);
    }
  }
}
